import { useEffect, useState } from 'react'

const INITIAL_SECONDS = 14 * 60 + 59 // 14:59

// Module-level shared state — all consumers read from the same value
let sharedTimeLeft = INITIAL_SECONDS
let listeners: Set<(t: number) => void> = new Set()
let intervalId: ReturnType<typeof setInterval> | null = null

function startGlobalTimer() {
  if (intervalId !== null) return
  intervalId = setInterval(() => {
    sharedTimeLeft = sharedTimeLeft <= 1 ? INITIAL_SECONDS : sharedTimeLeft - 1
    listeners.forEach((fn) => fn(sharedTimeLeft))
  }, 1000)
}

function stopGlobalTimer() {
  if (intervalId !== null && listeners.size === 0) {
    clearInterval(intervalId)
    intervalId = null
  }
}

export function useCountdown() {
  const [timeLeft, setTimeLeft] = useState(sharedTimeLeft)

  useEffect(() => {
    listeners.add(setTimeLeft)
    startGlobalTimer()
    // Sync immediately in case value changed between render and effect
    setTimeLeft(sharedTimeLeft)

    return () => {
      listeners.delete(setTimeLeft)
      stopGlobalTimer()
    }
  }, [])

  const minutes = Math.floor(timeLeft / 60)
  const seconds = timeLeft % 60
  const formatted = `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`

  return { timeLeft, minutes, seconds, formatted }
}
